export const DEFAULT_PRECISION = 9;
export const DEFAULT_MIN_PRECISION = 3;
export const DEFAULT_DECIMAL_UNITS = 9;

// Decimal units on the Fuel Network
export const DECIMAL_FUEL = 9;

// Decimal units on the Ethereum network
export const DECIMAL_WEI = 18;
export const DECIMAL_KWEI = 15;
export const DECIMAL_MWEI = 12;
export const DECIMAL_GWEI = 9;
